var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnalyticsCard = function SvgAnalyticsCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.056 0 0 4.056 0 9s4.056 9 9 9 9-4.056 9-9-4.056-9-9-9Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.783 12.75-.521-.52L11.65 9 8.262 5.77l.52-.52L12.75 9l-3.967 3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2 9.383H5.25v-.766h6.95z"
  })))));
};
export default SvgAnalyticsCard;